import { getPerformance } from 'firebase/performance';
import isPrerenderCrawler from 'helpers/isPrerenderCrawler';
import firebase from '.';

const initializePerformanceMonitoring = () => {
  if (isPrerenderCrawler()) {
    return null;
  }

  const performanceMonitoring = getPerformance(firebase);

  return performanceMonitoring;
};

export default initializePerformanceMonitoring;
